import React, { useEffect, useState } from 'react'

function TeamSquadImage({player, playersFB, playersAPI}) {

    const [playerImage, setPlayerImage] = useState("https://firebasestorage.googleapis.com/v0/b/backend-footgrail.appspot.com/o/players%2Favatar-default.jpg?alt=media&token=06ae4bfc-6276-40aa-ad58-0968fea10f8e")

    useEffect(() => {

        if (player && playersFB) {
            const currentPlayer = playersFB.filter(currentPlayer => +currentPlayer.player_id === +player.player_id)
            console.log(currentPlayer, "currentPlayer")
            if (currentPlayer.length) {
                setPlayerImage(currentPlayer[0].player_image)
            }
            
        }

    }, [playersFB, player])

    return (
        <img src={playerImage} className="img-fluid player-image" alt={player?.name || "player-squad"} />
    )
}
export default TeamSquadImage